import React from 'react'
import '../../styles/style-ind.css'
import { useMediaQuery } from "react-responsive";

const SectionTwo = () => {


    // const pricingData = [
    //     { feature: "Monthly Cost", growth: "Starting ₹3,800", pro: "Starting ₹30,000", enterprise: "Custom" },
    //     { feature: "Channels", growth: "WhatsApp", pro: "WhatsApp, FB + Insta, SMS + Email", enterprise: "WhatsApp, FB + Insta, SMS + Email" },
    //     { feature: "Broadcast Campaigns", growth: true, pro: true, enterprise: true },
    //     { feature: "DIY Automations", growth: true, pro: true, enterprise: true },
    //     { feature: "Customer Segmentation", growth: true, pro: true, enterprise: true },
    //     { feature: "Smart Retry", growth: true, pro: true, enterprise: true },
    //     { feature: "KwikPass Integration", growth: false, pro: true, enterprise: true },
    //     { feature: "Kwik Insights", growth: false, pro: true, enterprise: true },
    //     { feature: "AI Calling", growth: false, pro: false, enterprise: true },
    //     { feature: "Support – Chat Panel", growth: true, pro: true, enterprise: true },
    //     { feature: "DIY Chatbot Builder", growth: true, pro: true, enterprise: true },
    //     { feature: "AI Chatbot", growth: false, pro: true, enterprise: true },
    //     { feature: "Custom Automations", growth: false, pro: true, enterprise: true },
    //     { feature: "RFM + Cohort Analysis", growth: false, pro: true, enterprise: true },
    //     { feature: "A/B Testing", growth: false, pro: true, enterprise: true },
    //     { feature: "Custom Events", growth: false, pro: false, enterprise: true },
    //     { feature: "Live Segments", growth: false, pro: false, enterprise: true },
    //     { feature: "App Integrations (e.g., Appbrew)", growth: false, pro: false, enterprise: true },
    //     { feature: "Dedicated customer success manager", growth: 'Only email support', pro: true, enterprise: true }
    // ]



    const tools = [
        {
            title: 'A/B Testing',
            desc: `Optimize what you send, when you send it, and who you send it to — across WhatsApp, Email, SMS, and onsite journeys.`,
            img: '/assets/images/kwikpricing/img1-inter.png',
            alt: 'KwikPass preview',

        },
        {
            title: 'AI Chatbot',
            desc: `Recover abandoned carts, resolve queries, and re-engage shoppers instantly with AI-powered chat support .`,
            img: '/assets/images/kwikpricing/img2-inter.png',
            alt: 'Kwik Insights dashboard',

        },
        {
            title: 'AI-Powered Retries',
            desc: `Improve message delivery rates by up to 20% with intelligent, AI-driven retry logic that automatically resends failed messages at the right time — no manual effort needed.`,
            img: '/assets/images/kwikpricing/img4-india-inter.png',
            alt: 'AI-Powered Retries',

        }
    ];


    const isMobile = useMediaQuery({ maxWidth: 768 });

    return (
        <div className='price-inter-three'>


            <div className="pricing-tools">
                <h1 className="price-plan-heading-tool">Built-in Tools That Set Us Apart</h1>
                <div className="timeline-root">
                    {tools.map((tool, idx) => (
                        <div className="timeline-section" key={tool.title}>
                            <div className="timeline-marker">

                                {!isMobile && idx !== 0 && <div className="timeline-line" />}
                                <div className="timeline-dot" />
                                {idx !== tools.length && <div className="timeline-line timeline-line-down" />}
                            </div>
                            <div className="timeline-content">
                                <div className="timeline-text">
                                    <h2>{tool.title}</h2>
                                    <p>{tool.desc}</p>
                                </div>
                                <div className="timeline-img">
                                    <img src={tool.img} alt={tool.alt} />
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>

        </div>
    )
}

export default SectionTwo
